import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

/**
 * Soft delete a form template
 */
export async function deleteFormsTemplate(
  templateId: string
): Promise<{ success: boolean }> {
  try {
    const res = await fetcher(`${BASE_URL}/${templateId}`, {
      method: 'DELETE',
    });

    if (!res.ok) {
      console.error('Failed to delete form template:', await res.text());
      return { success: false };
    }

    return { success: true };
  } catch (err) {
    console.error('Error deleting form template:', err);
    return { success: false };
  }
}
